import { AccountRepository } from '../Repositories/AccountRepository';

export class DeleteAccountsUseCase {
  constructor(private repo: AccountRepository) {}

  execute(ids: number[]): Promise<void> {
    return Promise.all(ids.map(id => this.repo.deleteAccount(id))).then(() => undefined);
  }
}
